import { render } from "./GalleryComponent.vue?vue&type=template&id=16a71dc2&scoped=true"
import script from "./GalleryComponent.vue?vue&type=script&lang=js"
export * from "./GalleryComponent.vue?vue&type=script&lang=js"

import "./GalleryComponent.vue?vue&type=style&index=0&id=16a71dc2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a71dc2"]])

export default __exports__